"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const intl_1 = require("@kyruus/intl");
const card_container_1 = __importDefault(require("../CardContainer/card-container"));
const styles_1 = require("./styles");
const messages_1 = __importDefault(require("../../lib/messages"));
const network_affiliations_1 = __importDefault(require("./network-affiliations"));
const telehealth_1 = __importDefault(require("./telehealth"));
const age_groups_seen_1 = __importDefault(require("./age-groups-seen"));
const languages_1 = __importDefault(require("./languages"));
const insurance_plans_1 = __importDefault(require("./insurance-plans"));
const gender_1 = __importDefault(require("./gender"));
const ProviderHighlights = ({ provider, config, bookOnlineUrl, hasAvailability, shouldHidePageAnchors, onBook, shouldSkipHighlightsNavRender, intl }) => {
    const [hasDataInHighlightsCards, setHasDataInHighlightsCards] = (0, react_1.useState)(new Set());
    // Callback to set state when each card renders
    const handleCardsRender = (component) => {
        setHasDataInHighlightsCards((prevSet) => new Set(prevSet).add(component));
    };
    // If all highlights data is not present, skip rendering the highlights section
    if (hasDataInHighlightsCards.size === 6) {
        // callback to parent provider-profile component to skip rendering the highlights nav
        shouldSkipHighlightsNavRender();
        return null;
    }
    return (react_1.default.createElement(card_container_1.default, null,
        react_1.default.createElement(styles_1.HighlightsSectionHeader, { "aria-label": intl.formatMessage(messages_1.default.ariaHighlights), id: "profile-highlights-section" },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.highlightsHeader))),
        react_1.default.createElement(styles_1.CardsContainer, null,
            react_1.default.createElement(telehealth_1.default, { provider: provider, config: config, bookOnlineUrl: bookOnlineUrl, hasAvailability: hasAvailability, shouldHidePageAnchors: shouldHidePageAnchors, onBook: onBook, shouldSkipRender: handleCardsRender }),
            react_1.default.createElement(age_groups_seen_1.default, { provider: provider, config: config, shouldSkipRender: handleCardsRender }),
            react_1.default.createElement(languages_1.default, { provider: provider, config: config, shouldSkipRender: handleCardsRender }),
            react_1.default.createElement(insurance_plans_1.default, { provider: provider, config: config, shouldHidePageAnchors: shouldHidePageAnchors, shouldSkipRender: handleCardsRender }),
            react_1.default.createElement(gender_1.default, { provider: provider, config: config, shouldSkipRender: handleCardsRender })),
        react_1.default.createElement(network_affiliations_1.default, { provider: provider, config: config, shouldSkipRender: handleCardsRender })));
};
exports.default = (0, intl_1.injectIntl)(ProviderHighlights);
//# sourceMappingURL=provider-highlights.js.map